import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const MarketingNav = ({ showSectionLinks = true }) => (
  <nav>
    <Link to="/" className="nav-logo">
      <Logo />
      memorloko
    </Link>
    <div className="nav-links">
      {showSectionLinks && (
        <>
          <a href="/#how-it-works">How It Works</a>
          <a href="/#pricing">Pricing</a>
          <a href="/#faq">FAQ</a>
        </>
      )}
      <Link to="/signup" className="btn btn-primary" style={{ marginLeft: 8 }}>
        Get Started
      </Link>
    </div>
  </nav>
);

export default MarketingNav;
